import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { to: '/', label: 'Overview' },
  { to: '/services', label: 'Services' },
  { to: '/about', label: 'About' },
  { to: '/our-clients', label: 'Our Clients' },
  { to: '/career', label: 'Career' },
  { to: '/internship', label: 'Internship' },
];

export default function Header({ onMenuToggle, mobileOpen = false }) {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  return (
    <header
      className={`main-header main-header-one z-50 border-b transition-all duration-300 ${
        scrolled
          ? 'border-slate-200/80 bg-white/95 shadow-[0_4px_24px_rgba(15,23,42,0.12)] backdrop-blur-xl'
          : 'border-transparent bg-gradient-to-r from-sky-50 via-white to-white shadow-[0_10px_30px_rgba(15,23,42,0.04)] backdrop-blur-md'
      }`}
      style={{ position: 'fixed', top: 0, left: 0, right: 0 }}
    >
      <div className="container">
        <div className="flex items-center justify-between gap-3 py-3 sm:py-4">
          {/* Logo */}
          <Link to="/" className="flex shrink-0 items-center gap-3">
            <img
              src="magizhinilogo.png"
              alt="Magizhini"
              className="header-logo block h-auto w-auto max-w-[120px] sm:max-w-[160px]"
            />
          </Link>

          {/* Mobile toggle — class name intentionally NOT 'mobile-nav__toggler'
               so the legacy ontech.js jQuery handler doesn't intercept this click.
               React owns the open/close state; Shell.jsx applies the 'expanded' class. */}
          <button
            id="mobile-menu-btn"
            type="button"
            className="nav-toggler-btn xl:hidden ml-auto inline-flex h-11 w-11 flex-none items-center justify-center rounded-full border border-slate-200 bg-white shadow-sm transition-all hover:border-brand/30 hover:text-brand hover:shadow-md"
            style={{ color: '#0f172a' }}
            onClick={onMenuToggle}
            aria-label={mobileOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-expanded={mobileOpen}
            aria-controls="mobile-nav-drawer"
          >
            <i className={`fa ${mobileOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>

          {/* Nav */}
          <nav className="hidden xl:flex items-center">
            <ul className="main-menu__list m-0 flex items-center gap-8 list-none">
              {NAV_ITEMS.map(({ to, label }) => {
                const active = isActive(to);
                return (
                  <li key={to} className="relative">
                    <Link
                      className={`inline-block py-1 text-[15px] font-semibold tracking-tight transition-colors ${
                        active
                          ? 'text-brand-dark'
                          : 'text-slate-600 hover:text-brand-dark'
                      }`}
                      to={to}
                      aria-current={active ? 'page' : undefined}
                    >
                      {label}
                    </Link>
                    <span
                      className={`absolute -bottom-1 left-0 h-[2px] w-full rounded-full bg-brand transition-opacity ${
                        active ? 'opacity-100' : 'opacity-0'
                      }`}
                    />
                  </li>
                );
              })}
            </ul>
          </nav>

          {/* CTA */}
          <Link
            to="/contact"
            className="hidden xl:inline-flex shrink-0 items-center rounded-full bg-brand-dark px-6 py-3 text-sm font-semibold text-white shadow-md shadow-brand-dark/20 transition-all hover:-translate-y-0.5 hover:bg-brand hover:shadow-lg hover:shadow-brand/25"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </header>
  );
}

